module.exports = __webpack_public_path__ + "static/media/movie.261a12ce.svg";